import { SourcingEventStatus, type SourcingEventV2Dto } from "../../../autogen/bff-api";
import { isSchemeProcedure } from "../../sourcing-events/buyer/wizard/utils/procedure";
import { DEFAULT_TAB, visibleEventTabs, type EventTab } from "./eventTabDefinitions";
import { deriveTimelinePhase, type TimelinePhaseKey } from "./timeline/deriveTimelinePhase";

const TAB_FOR_PHASE: Record<TimelinePhaseKey, EventTab> = {
  announcement: "request",
  questionDeadline: "request",
  requestDeadline: "qualification",
  qualification: "qualification",
  bidDeadline: "minimumRequirements",
  evaluationStart: "evaluation",
  awardDecision: "award",
  standstillExpiry: "award",
  contractSigning: "award",
};

export const defaultEventTab = (event: SourcingEventV2Dto, now: number): EventTab => {
  const visible = visibleEventTabs(event);
  const isShown = (tab: EventTab) => visible.some((candidate) => candidate.key === tab);

  const procedureType = event.eventContext.type === "Public" ? event.eventContext.procedureType : undefined;
  if (isSchemeProcedure(procedureType)) {
    return isShown("dpsSuppliers") ? "dpsSuppliers" : DEFAULT_TAB;
  }

  const activeKey =
    event.status === SourcingEventStatus.Evaluated || event.status === SourcingEventStatus.Completed
      ? "awardDecision"
      : deriveTimelinePhase(event, now).activeKey;
  if (activeKey == null) return DEFAULT_TAB;

  const preferred = TAB_FOR_PHASE[activeKey];
  if (isShown(preferred)) return preferred;

  const fallbackOrder: EventTab[] = ["qualification", "minimumRequirements", "bids", "evaluation", "award"];
  const from = fallbackOrder.indexOf(preferred);
  const next = from === -1 ? undefined : fallbackOrder.slice(from + 1).find(isShown);
  return next ?? DEFAULT_TAB;
};
